// Display format for Frigg tariffs, e.g. "0.1kr/min+2.9kr/kWh" -> "0,1 NOK/min + 2,9 NOK/kWh".
// A non-breaking space keeps each amount on the same line as its unit.
// Only for rendering: the raw tariff string is what gets sent with the payment request.
export function formatTariff(tariff: string): string {
    return tariff
        .replace(/(\d)\.(\d)/g, "$1,$2")
        .replace(/\s*kr\//g, "\u00A0NOK/")
        .replace(/\s*\+\s*/g, " + ");
}
